import { Collapse } from '@mui/material'
import { useEffect, useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { TIMERS_OBJECT_EMPTY } from 'src/consumer/components/TimersPage/utils'
import { PRACTICE_TIMER_TYPES } from 'src/consumer/constants'
import GenericTimerSelectionWrapper from './GenericTimerSelectionWrapper'
import SelectedTime from './components/SelectedTime/SelectedTime'
import { getIntervalDurationLimits } from './components/TimerSettings/AddTimerIntervalsUtils'
import TimerSettings from './components/TimerSettings/TimerSettings'
import TimerTypeSelection from './components/TimerTypeSelection/TimerTypeSelection'
import {
  GenericTimerButtonsAndSettingsContainer,
  GenericTimerStartPracticeButton,
} from './components/styledComponents'

export default function GenericTimerSelectionComponent() {
  const [settings, setSettings] = useState(TIMERS_OBJECT_EMPTY)
  const navigate = useNavigate()

  const intervalDurationLimits = useMemo(() => {
    return getIntervalDurationLimits(
      settings?.durationType,
      settings?.duration,
      settings?.maxDuration,
    )
  }, [settings])

  const disableStartTimer = useMemo(() => {
    if (isNaN(settings?.duration) || settings?.duration <= 0) {
      return true
    }
    if (settings?.durationType === PRACTICE_TIMER_TYPES.range) {
      if (isNaN(settings?.maxDuration)) {
        return true
      } else {
        if (settings?.maxDuration <= settings?.duration) {
          return true
        }
      }
    }
    if (settings?.intervals?.some((interval) => interval > intervalDurationLimits?.max)) {
      return true
    }

    return false
  }, [settings])

  const showAdditionalSettings = useMemo(() => {
    switch (settings?.durationType) {
      case PRACTICE_TIMER_TYPES.fixed:
      case PRACTICE_TIMER_TYPES.range:
      case PRACTICE_TIMER_TYPES.unlimited:
        return true
      default:
        return false
    }
  }, [settings?.durationType])

  function changeTimerType(value) {
    setSettings((prev) => ({ ...prev, durationType: value }))
  }

  function startTimer() {
    var timerDataToSend = {
      ...settings,
    }
    if (timerDataToSend?.durationType === PRACTICE_TIMER_TYPES.range) {
      timerDataToSend.minDuration = settings.duration
    }
    navigate(`/timer/my-timer`, {
      state: { item: timerDataToSend },
    })
  }

  useEffect(() => {
    console.log({ settings })
  }, [settings])

  return (
    <GenericTimerSelectionWrapper>
      <SelectedTime
        timeInMilliseconds={settings.duration}
        timerType={settings?.durationType}
        setTimerSettings={setSettings}
      />
      <TimerTypeSelection setTimerType={changeTimerType} timerType={settings?.durationType} />
      <Collapse sx={{ width: '100%' }} in={showAdditionalSettings} unmountOnExit>
        <TimerSettings
          timerSettings={settings}
          setTimerSettings={setSettings}
          intervalDurationLimits={intervalDurationLimits}
        />
      </Collapse>
      <GenericTimerButtonsAndSettingsContainer>
        <GenericTimerStartPracticeButton disabled={disableStartTimer} onClick={startTimer}>
          Start Timer
        </GenericTimerStartPracticeButton>
        {/* <AdditionalOptionsButton onClick={toggleAdditionalSettings}>
          <span style={{ margin: 0 }}>Additional Options</span>{' '}
          <ExpandLess sx={{ transform: 'rotate(180deg)' }} />
        </AdditionalOptionsButton> */}
      </GenericTimerButtonsAndSettingsContainer>
    </GenericTimerSelectionWrapper>
  )
}
